import React from 'react'
import { Input, Select, DatePicker } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

const { Option } = Select
const { RangePicker } = DatePicker

const ActivityFilters = ({ filterValues, filterState }) => {
  const {
    searchText,
    setSearchText,
    caregiverFilter,
    setCaregiverFilter,
    activityTypeFilter,
    setActivityTypeFilter,
    statusFilter,
    setStatusFilter,
    dateRange,
    setDateRange
  } = filterState

  const { caregivers, activityTypes, statuses } = filterValues

  return (
    <div style={{ marginBottom: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'center' }}>
      <Input
        placeholder='Search activities'
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{ width: 250 }}
        prefix={<SearchOutlined />}
        allowClear
      />

      <Select
        placeholder='Caregiver'
        style={{ width: 200 }}
        value={caregiverFilter}
        onChange={(value) => setCaregiverFilter(value)}
      >
        <Option value='all'>All Caregivers</Option>
        {caregivers.map((caregiver) => (
          <Option key={caregiver} value={caregiver}>
            {caregiver}
          </Option>
        ))}
      </Select>

      <Select
        placeholder='Activity Type'
        style={{ width: 180 }}
        value={activityTypeFilter}
        onChange={(value) => setActivityTypeFilter(value)}
      >
        <Option value='all'>All Activity Types</Option>
        {activityTypes.map((type) => (
          <Option key={type} value={type}>
            {type}
          </Option>
        ))}
      </Select>

      <Select
        placeholder='Status'
        style={{ width: 150 }}
        value={statusFilter}
        onChange={(value) => setStatusFilter(value)}
      >
        <Option value='all'>All Statuses</Option>
        {statuses.map((status) => (
          <Option key={status} value={status}>
            {status}
          </Option>
        ))}
      </Select>

      <RangePicker onChange={(dates) => setDateRange(dates)} value={dateRange} style={{ width: 280 }} />
    </div>
  )
}

export default ActivityFilters
